<template>
  <v-container>

  </v-container>
</template>

<script>
import store from '@/store'

export default {

  name: 'home',
  data() {
    return {
      currentUser: store.getters.loggedUser

    };
  },
  created() {
    console.log(this.currentUser);
    var role = this.currentUser.role;
    if (role === 'CANDIDATO'){
      this.$router.push('/candidato')
    } else {
      this.$router.push('/administrador')
    }
  },
  methods: {
    
  }
};
</script>
